import React, { useState } from 'react';
import { Col, Container, Row, Form } from 'react-bootstrap';
import { useForm } from 'react-hook-form';
import axios from "axios";
import { toast } from 'react-toastify';
import Loader from '../Loader';

const Forgotpassword = () => {
  const { register, handleSubmit, formState: { errors }, reset } = useForm({ defaultValues: { email: "" } });
  const [loader, setLoader] = useState(false);
  const handleForgotPassword = (data) => {
    setLoader(true);
    axios({
      method: "POST",
      url: `${process.env.REACT_APP_BASE_URL}/user/forgot-password`,
      headers: {
        "Content-Type": "application/json"
      },
      data: JSON.stringify({
        email: data.email
      }),
    }).then(res => {
      setLoader(false);
      reset({ email: "" });
      return toast(res.data.message || "Reset password link sended your email", {
        theme: "light",
        type: "success",
        position: "top-right"
      });
    }).catch(err => {
      setLoader(false);
      if (err?.response?.data?.errors) {
        return toast(err?.response?.data?.errors[0]?.msg || "Error 500", {
          theme:"light",
          type:"error",
          position:"top-right"
        });
      } else {
        return toast(err?.response?.data?.message || err.message || "Forgot password was unsuccessful", {
          theme: "light",
          type: "error",
          position: "top-right"
        });
      }
    });
  }
  return (
    <>
      <section className='form-section forgotpassword'>
        <Container>
          <Row className="justify-content-center">
            <Col xxl={8} md={8} sm={10}>
              <div className="boxwrap">
                <h2 className='text-gradient'>Forgot Password</h2>
                <p className="mb-3">Provide your account's email for which you want to reset your password</p>
                <Form onSubmit={handleSubmit(handleForgotPassword)} className="row">
                  <Form.Group as={Col} md="12" className="mb-3" controlId="forgotpassword-Email">
                    <Form.Label>Email address <span>*</span></Form.Label>
                    <Form.Control
                      type="email" placeholder='Please enter your email address'
                      {...register("email", {
                        required: { message: "E-Mail is require", value: true },
                        pattern: { message: 'E-Mail is not valid', value: /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/g }
                      })} />
                    {errors.email ? <p className='errMsg'>{errors.email.message}</p> : null}
                  </Form.Group>
                  <div className="mb-4">
                    <button type="submit" className="button blue w-100 py-3">Submit</button>
                  </div>
                </Form>
              </div>
            </Col>
          </Row>
        </Container>
      </section>
      <Loader show={loader}/>
    </>
  )
}

export default Forgotpassword